var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgEdit = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: 20,
  height: 20,
  fill: "none"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  fill: "#444",
  d: "M4.167 15.833h.915l8.915-8.915-.915-.915-8.915 8.915zm-.833.834v-2.1L14.317 3.573a1 1 0 0 1 .283-.176.9.9 0 0 1 .323-.064q.168 0 .325.054a.7.7 0 0 1 .291.19l.89.895a.7.7 0 0 1 .188.291q.05.159.05.317a1 1 0 0 1-.057.325.8.8 0 0 1-.181.282L5.432 16.667zM13.532 6.468l-.45-.465.915.915z"
})));
export { SvgEdit as ReactComponent };
export default __webpack_public_path__ + "82b0201586763ab7b6cc27838c441159.svg";